// facets-vertical.js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".bundle-filter-button").forEach((button) => {
    let input = button.querySelector("input");
    if (input.checked) {
      button.classList.add("checked");
    }
  });

  document.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const form = checkbox.closest('form');
      if (form) {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);
        FacetFiltersForm.renderPage(searchParams.toString(), null, true);
      }
    });
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".bundle-filter-button")) {
      let button = event.target.closest(".bundle-filter-button");
      let input = button.querySelector("input");

      if (input) {
        input.checked = !input.checked;
        button.classList.toggle("checked", input.checked);
      }
    }
  });

 const resetBtn =  document.getElementById("resetAllFilters")
 if(resetBtn) {
  resetBtn.addEventListener("click", function (event) {
    event.preventDefault();

    document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
    });

    const priceInputs = document.querySelectorAll('.price-range input[type="number"]');
    if (priceInputs.length) {
      priceInputs.forEach((input) => {
        input.value = input.getAttribute("placeholder");
      });
    }

    document.querySelectorAll(".bundle-filter-button").forEach((button) => {
      button.classList.remove("checked");
    });

    const form = document.getElementById("FacetFiltersForm");
    if (form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      FacetFiltersForm.renderPage(searchParams.toString(), null, true);
    } else {
      window.location.href = this.getAttribute("href");
    }
  });
}

  // Fix for show-more button (handle null case)
  const showMoreButton = document.querySelector(".button-show-more");
  if (showMoreButton) {
    // Remove existing event listener if any
    const oldHandler = showMoreButton._clickHandler;
    if (oldHandler) {
      showMoreButton.removeEventListener("click", oldHandler);
    }

    // Add new event listener
    const clickHandler = function() {
      const showMoreContainer = this.closest("show-more-button");
      if (showMoreContainer) {
        showMoreContainer.classList.toggle("custom-active");
      }
    };
    showMoreButton.addEventListener("click", clickHandler);
    showMoreButton._clickHandler = clickHandler;
  }

  // Re-initialize wishlist if available
  if (window.reinitializeWishlist) {
    window.reinitializeWishlist();
  }

  // Re-initialize category scroll if available
  if (window.reinitializeCategoryScroll) {
    window.reinitializeCategoryScroll();
  }
});

// // Re-initialize after Shopify section updates
// document.addEventListener("shopify:section:load", function () {
//   initializeFacetsVertical();
// });

// // Expose function for external use
// window.initializeFacetsVertical = initializeFacetsVertical;

// // Add listener for facet updates
// document.addEventListener("facet:update", () => {
//   setTimeout(initializeFacetsVertical, 100);
// });
